enum ActivityStatus {
  ACTIVE = 'ACTIVE',
  NOT_ACTIVE = 'NOT_ACTIVE',
  ALL = 'ALL',
}

export default ActivityStatus;
